import createI18nInstance from '../../../services/i18n/index.js';
import { createCxProps } from './utils.js';

const getVisibleOffersCount = (el, campaignData) => {
  const DEFAULT_VISIBLE_OFFERS_COUNT = 3;
  const attrValue = el.getAttribute('visible-offers-count');

  if (attrValue) {
    return (
      Math.abs(Number.parseInt(attrValue, 10)) || DEFAULT_VISIBLE_OFFERS_COUNT
    );
  }

  return campaignData.initialOffersToShow || DEFAULT_VISIBLE_OFFERS_COUNT;
};

export const createOfferContract = (
  variant,
  themesGetter,
  customCreateDehydratedState = null
) => {
  return async (campaignData, el) => {
    const theme = el.getAttribute('theme') || campaignData?.theme || 'default';
    const placeholders = el.getAttribute('placeholders');
    const disableAnalytics = el.hasAttribute('disable-analytics');

    if (
      !campaignData ||
      !Array.isArray(campaignData.offers) ||
      !campaignData.offers.length
    ) {
      return null;
    }

    const i18n = campaignData?.repub
      ? await createI18nInstance(campaignData.repub)
      : null;

    const dataLayer = campaignData?.analytics?.getDataLayer?.();

    const analytics = {
      disableAnalytics,
      ...(dataLayer && { dataLayer })
    };

    const baseProps = {
      data: campaignData,
      variant,
      theme,
      analytics,
      placeholders,
      ...(i18n && { i18n })
    };

    const variantSpecificProps = {};

    if (variant === 'offers-carousel') {
      const themeData = themesGetter?.(theme);
      const poweredBy = campaignData?.poweredBy || themeData?.poweredBy || '';
      variantSpecificProps.poweredBy = poweredBy;
    }

    if (variant === 'offers-grouped') {
      const themeData = themesGetter?.(theme);
      const geolocation = campaignData.geolocation;

      const poweredBy =
        campaignData?.poweredBy ||
        (typeof themeData?.poweredBy === 'function'
          ? themeData.poweredBy(geolocation)
          : themeData?.poweredBy) ||
        '';

      const footerNotice =
        campaignData?.footerNotice ||
        (typeof themeData?.footerNotice === 'function'
          ? themeData.footerNotice(geolocation)
          : themeData?.footerNotice) ||
        '';

      const footerIcons =
        campaignData?.footerIcons || themeData?.footerIcons || '';

      variantSpecificProps.poweredBy = poweredBy;
      variantSpecificProps.footerNotice = footerNotice;
      variantSpecificProps.footerIcons = footerIcons;
      variantSpecificProps.initialOffersToShow = getVisibleOffersCount(
        el,
        campaignData
      );
    }

    const cxProps = createCxProps(
      {
        ...baseProps,
        ...variantSpecificProps
      },
      customCreateDehydratedState
    );

    return cxProps;
  };
};
